function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 211,
  height: 55,
  rx: 5,
  fill: "#0084ff"
});

var _ref3 = /*#__PURE__*/React.createElement("text", {
  id: "Download_Windows-2",
  "data-name": "Download Windows",
  transform: "translate(49 35)",
  fill: "#fff",
  fontSize: 15,
  fontFamily: "SegoeUI, Segoe UI"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Download Windows"));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "windows",
  transform: "translate(20 19)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M0,1V6.72H8.006V0Z",
  transform: "translate(0 1.287)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M0,1.144V8.006H9.15V0Z",
  transform: "translate(9.15)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M0,0V6.863L9.15,8.006V0Z",
  transform: "translate(9.15 9.15)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-4",
  "data-name": "Path",
  d: "M0,0V5.719l8.006,1V0Z",
  transform: "translate(0 9.15)",
  fill: "#fff"
}));

function SvgDesktop1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_Windows",
    "data-name": "Download Windows",
    xmlns: "http://www.w3.org/2000/svg",
    width: 211,
    height: 55,
    viewBox: "0 0 211 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop1);
export default __webpack_public_path__ + "static/media/desktop1.c6dd3811.svg";
export { ForwardRef as ReactComponent };